module.exports = __webpack_public_path__ + "img/submitted.abf877c9.svg";